export type FrameInfo = {
    name: string,
    nameKey: string,
    edition: 'normal' | 'extendend' | 'fanmade',
    labelColor: string,
    labelBackgroundColor?: string,
    labelBackgroundColorList?: string[],
    labelBackgroundImage?: string,
    sortWeight: number,
    isOfficial: boolean,
};
export const FrameInfoMap: Record<string, FrameInfo> = {
    'normal': {
        name: 'normal',
        nameKey: 'input.frame.normal',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#c49c5e',
        sortWeight: 100,
        isOfficial: true,
    },
    'effect': {
        name: 'effect',
        nameKey: 'input.frame.effect',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#b96c49',
        sortWeight: 90,
        isOfficial: true,
    },
    'ritual': {
        name: 'ritual',
        nameKey: 'input.frame.ritual',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#5e85c9',
        sortWeight: 85,
        isOfficial: true,
    },
    'fusion': {
        name: 'fusion',
        nameKey: 'input.frame.fusion',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#8948a4',
        sortWeight: 80,
        isOfficial: true,
    },
    'synchro': {
        name: 'synchro',
        nameKey: 'input.frame.synchro',
        labelColor: '#000',
        edition: 'normal',
        labelBackgroundColor: '#efefef',
        sortWeight: 70,
        isOfficial: true,
    },
    'xyz': {
        name: 'xyz',
        nameKey: 'input.frame.xyz',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#000000',
        sortWeight: 60,
        isOfficial: true,
    },
    'link': {
        name: 'link',
        nameKey: 'input.frame.link',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#0c8ac6',
        sortWeight: 50,
        isOfficial: true,
    },
    'spell': {
        name: 'spell',
        nameKey: 'input.frame.spell',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#1b8f83',
        sortWeight: 30,
        isOfficial: true,
    },
    'trap': {
        name: 'trap',
        nameKey: 'input.frame.trap',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#c32a8c',
        sortWeight: 25,
        isOfficial: true,
    },
    'token': {
        name: 'token',
        nameKey: 'input.frame.token',
        labelColor: '#ffffff',
        edition: 'normal',
        labelBackgroundColor: '#666c74',
        sortWeight: 1,
        isOfficial: true,
    },
    'dark-synchro': {
        name: 'dark-synchro',
        nameKey: 'input.frame.dark-synchro',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#4d4543',
        sortWeight: 15,
        isOfficial: true,
    },
    'obelisk': {
        name: 'obelisk',
        nameKey: 'input.frame.obelisk',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#515eb0',
        sortWeight: 10,
        isOfficial: true,
    },
    'osiris': {
        name: 'osiris',
        nameKey: 'input.frame.osiris',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#bd5044',
        sortWeight: 9,
        isOfficial: true,
    },
    'ra': {
        name: 'ra',
        nameKey: 'input.frame.ra',
        labelColor: '#000',
        edition: 'extendend',
        labelBackgroundColor: '#b9ad34',
        sortWeight: 8,
        isOfficial: true,
    },
    'raviel': {
        name: 'raviel',
        nameKey: 'input.frame.raviel',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#313c5f',
        sortWeight: 7,
        isOfficial: true,
    },
    'uria': {
        name: 'uria',
        nameKey: 'input.frame.uria',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#623320',
        sortWeight: 6,
        isOfficial: true,
    },
    'hamon': {
        name: 'hamon',
        nameKey: 'input.frame.hamon',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#534a19',
        sortWeight: 5,
        isOfficial: true,
    },
    'lg-dragon': {
        name: 'lg-dragon',
        nameKey: 'input.frame.lg-dragon',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#4e84a4',
        sortWeight: 3,
        isOfficial: true,
    },
    'speed-skill': {
        name: 'speed-skill',
        nameKey: 'input.frame.speed-skill',
        labelColor: '#ffffff',
        edition: 'extendend',
        labelBackgroundColor: '#199cd5',
        sortWeight: 2,
        isOfficial: true,
    },
    'zarc': {
        name: 'zarc',
        nameKey: 'input.frame.zarc',
        labelColor: '#000',
        edition: 'extendend',
        labelBackgroundColorList: [
            'rgba(185,108,73,1)',
            'rgba(137,72,164,1)',
            'rgba(239,239,239,1)',
            'rgba(0,0,0,1)',
        ],
        labelBackgroundImage: `linear-gradient(90deg, ${[
            'rgba(185,108,73,1) 23%',
            'rgba(137,72,164,1) 27%',
            'rgba(137,72,164,1) 49%',
            'rgba(239,239,239,1) 51%',
            'rgba(239,239,239,1) 73%',
            'rgba(0,0,0,1) 77%',
        ].join(', ')})`,
        sortWeight: 4,
        isOfficial: true,
    },
    'rebirth': {
        name: 'rebirth',
        nameKey: 'input.frame.rebirth',
        labelColor: '#000000',
        edition: 'fanmade',
        labelBackgroundColor: '#ff9e03',
        sortWeight: 100,
        isOfficial: false,
    },
};
export const frameList = Object.values(FrameInfoMap);
export const DefaultFrameInfo = FrameInfoMap['effect'];

export const FramePositionMap: Record<string, { labelKey: string }> = {
    bottomLeftFrame: { labelKey: 'input.advanced-frame.name.bottom-left' },
    bottomRightFrame: { labelKey: 'input.advanced-frame.name.bottom-right' },
    effectBackground: { labelKey: 'input.advanced-frame.name.effect-background' },
    pendulumEffectBackground: { labelKey: 'input.advanced-frame.name.pendulum-effect-background' },
    frame: { labelKey: 'input.advanced-frame.name.primary' },
    topLeftFrame: { labelKey: 'input.advanced-frame.name.top-left' },
    topRightFrame: { labelKey: 'input.advanced-frame.name.top-right' },
    foil: { labelKey: 'input.foil.label' },
};